import { Component, OnInit, Input, Renderer2, ElementRef, forwardRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

/**
 * Wrapper for phone component using PrimeNG InputMaskModule
 */
@Component({
  selector: 'app-phone',
  templateUrl: './phone.component.html',
  styleUrls: ['./phone.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PhoneComponent),
      multi: true
    }
  ]
})
export class PhoneComponent implements OnInit {
  /**
   * indicate if control is disabled
   */
  isDisabled = false;

  /**
   * on change event of the dropdown
   */
  private onChange;

  /**
   * on touched event of the dropdown
   */
  private onTouched;

  /**
   * value to be bound to the dropdown
   */
  private _value = '';

  /**
   * touch event handler
   */
  private onTouch: any = () => {};

  /**
   * getter for the value
   */
  @Input()
  get value(): any {
    return this._value;
  }

  /**
   * setter for the value
   */
  set value(value: any) {
    if (value !== this._value) {
      this._value = value;
      if (this._value) {
        this.onChange(
          this._value
            .replace('(', '')
            .replace(') ', '')
            .replace(')', '')
            .replace('-', '')
        );
      } else {
        this.onChange(this._value);
      }
    }
  }

  /**
   * constructor to inject dependency
   * @param renderer instance of renderer2
   * @param element instance of element
   */
  constructor(private renderer: Renderer2, private element: ElementRef) {
    this.onChange = (_: any) => {};
    this.onTouched = () => {};
  }

  /**
   * initialize component
   */
  ngOnInit(): void {}

  /**
   * set the value to the dropdown
   * @param obj value to be written to the dropdown
   */
  writeValue(obj: any): void {
    this.value = obj;
  }

  /**
   * handler change function
   * @param fn change fn
   */
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  /**
   * handler touch function
   * @param fn touch fn
   */
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  /**
   * set control to disabled state
   * @param disabled is control disabled
   */
  setDisabledState?(disabled: boolean): void {
    this.isDisabled = disabled;
    this.renderer.setAttribute(this.element.nativeElement, 'disabled', disabled.toString());
    this.element.nativeElement.setAttribute('disabled', disabled.toString());
  }
}
